(() => {
  const f = document.querySelector('[data-fs-facets]'); if (!f || f.dataset.ready) return; f.dataset.ready = 1;
  const panel = f.querySelector('[data-fs-facet-panel]');
  const openBtn = f.querySelector('[data-fs-facet-open]');
  const go = () => {
    const fd = new FormData(f); const p = new URLSearchParams();
    for (const [k, v] of fd) if (String(v).trim() !== '') p.append(k, v);
    const u = f.getAttribute('action') + (p.toString() ? '?' + p.toString() : '');
    document.body.classList.add('fs-loading');
    window.location.assign(u);
  };
  let t;
  f.addEventListener('change', (e) => {
    if (e.target.type === 'number') { clearTimeout(t); t = setTimeout(go, 700); return; }
    go();
  });
  f.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  const setOpen = (on) => {
    panel.classList.toggle('is-open', on); openBtn.setAttribute('aria-expanded', on);
    document.documentElement.classList.toggle('fs-lock', on && matchMedia('(max-width: 1023px)').matches);
    if (on) panel.querySelector('summary, input')?.focus(); else openBtn.focus();
  };
  openBtn.addEventListener('click', () => setOpen(true));
  f.querySelectorAll('[data-fs-facet-close]').forEach(b => b.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false); });
})();
